import { LoadingView } from 'components/LoadingView';

export const LoadingLayout = () => <LoadingView />;
